import Image from 'next/image';
import Link from 'next/link';

// Treat bare values like 'pricing' or 'platform/overview/' as internal routes
// (prefix with '/') so they don't resolve relative to the current page.
// Absolute URLs, protocol-relative, mailto/tel, and hash/query links pass through.
const normalizeHref = url => {
  if (!url) return '/';
  if (/^(https?:)?\/\//i.test(url) || /^(mailto:|tel:|#|\?)/i.test(url) || url.startsWith('/')) {
    return url;
  }
  return `/${url}`;
};

const ArrowLink = ({url = 'company', text = 'Learn more'}) => {
  return (
    <Link href={normalizeHref(url)} legacyBehavior>
      <a className='arrow-link'>
        {text}
        <span className='arrow-wrapper'>
          <span className='arrow-nofill arrow'>
            <Image src='/svg/arrow-top-right.svg' className='svg' fill alt='link' unoptimized/>
          </span>
        </span>
      </a>
    </Link>
  );
};

export default ArrowLink;

